module.exports = __webpack_public_path__ + "media/images/registry_banner2-81419acc6cb0788df1aa8308ef03d843.jpg";